import type { Quotation } from './types';

/**
 * T11 — the customer's latest answer on the public quote link, shown under the
 * status badge on the list: the decline reason, or the newest change request
 * on a quote that is still open.
 */
export function QuotationResponseHint({
  quotation,
}: {
  quotation: Pick<Quotation, 'status' | 'rejection_reason' | 'last_change_request'>;
}) {
  const declined = quotation.status === 'REJECTED';
  const text = declined
    ? quotation.rejection_reason
    : quotation.status === 'ACTIVE'
      ? quotation.last_change_request
      : null;
  if (!text) return null;

  return (
    <span
      className={`max-w-[14rem] truncate text-[11px] ${
        declined ? 'text-danger-600 dark:text-danger-400' : 'text-violet-600 dark:text-violet-400'
      }`}
      title={text}
    >
      {declined ? 'Reason: ' : 'Changes asked: '}
      {text}
    </span>
  );
}
